import axios from 'axios'

export const client = axios.create({

});

client.interceptors.request.use((config) => {
    const token = document.head.querySelector(`meta[name="csrf-token"]`)
    if (token) {
        config.headers['X-CSRF-Token'] = token.getAttribute('content');
    }

    return config;
});

export default axios
